/* eslint-disable max-len */
import 'react';

const AddTagSvg = (props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h12v12H0z" />
            <g transform="translate(1 1)">
                <circle fill="currentColor" opacity=".7" cx="5" cy="5" r="5" />
                <g stroke="#FFF" strokeLinecap="round">
                    <path d="M3 5h4M5 3v4" />
                </g>
            </g>
        </g>
    </svg>
);
export default AddTagSvg;
